module.exports = __webpack_public_path__ + "img/mh.0b50de63.png";